import { useMemo } from "react";
import { useGetActuarialUserListQuery } from "../../api/actuarial/actuarial-api"
import { getErrorMessage } from "../../utils/get-error-message.utils";
import { DropdownOptionValue } from "../../components/ui/dropdown-option";
import { ActuarialDepartmentListResponseData } from "../../api/actuarial/actuarial-api-response";
import { selectApprovalModalOpen, selectApproverFormRates } from "../../features/actuarial/approval/approval-slice";
import { useSelector } from "react-redux";

export const useActuarialAccess = () => {
    
    const isOpenApprovalModal = useSelector(selectApprovalModalOpen)
    const { data: actuarialUsers, isLoading: isLoadingActuarialUsers, isError: isErrorActuarialUsers, error: errorActuarialUsers, refetch: refetchActuarialUsers, isFetching: isFetchingActuarialUsers } = useGetActuarialUserListQuery(undefined, { skip: !isOpenApprovalModal });
    const errorMessageActuarialUsers = getErrorMessage(errorActuarialUsers);

    const approverForm = useSelector(selectApproverFormRates);

    const defaultActuarialListType = useMemo(() => ({ id: 0, name: 'Select Approver', subTitle: '-', email: '-' }), []);

    const actuarialTypeOptions: DropdownOptionValue[] = useMemo(() => {
        return [
            defaultActuarialListType,
            ...(actuarialUsers?.map((item: ActuarialDepartmentListResponseData) => ({
                id: item.user_id,
                name: [item.firstname, item.middlename, item.lastname].filter(Boolean).join(' '),
                subTitle: item.position ?? '',
                email: item.email
            })) || []),
        ];
    }, [defaultActuarialListType, actuarialUsers]);
    
    const selectedApproverValue = useMemo(() => {
        return actuarialTypeOptions.find((option) => option.id === approverForm?.id) || defaultActuarialListType;
    }, [approverForm?.id, actuarialTypeOptions, defaultActuarialListType]);

    return {
        actuarialUsers,
        isLoadingActuarialUsers,
        isErrorActuarialUsers,
        errorActuarialUsers,
        refetchActuarialUsers,
        isFetchingActuarialUsers,
        errorMessageActuarialUsers,
        actuarialTypeOptions,
        selectedApproverValue,
    }
}